import React, { ReactNode } from 'react';
import SectionTitle from './SectionTitle';
import SectionDesc from './SectionDesc';
import cn from 'classnames';

type Props = {
  title?: string;
  desc?: string | ReactNode;
  children: ReactNode;
  whiteBgChildren?: boolean;
  withoutPadding?: boolean;
  'data-testid'?: string;
  actions?: React.ReactElement;
};

const SectionWrapper = ({
  desc,
  title,
  children,
  whiteBgChildren,
  withoutPadding,
  actions,
  'data-testid': testId,
}: Props) => {
  return (
    <section
      className="flex flex-col gap-6"
      data-testid={testId || 'section-wrapper'}
    >
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-1">
          {title && <SectionTitle text={title} />}
          {desc && (typeof desc === 'string' ? <SectionDesc text={desc} /> : desc)}
        </div>

        {actions}
      </div>
      <div
        className={cn({
          'rounded-md bg-white dark:bg-dark-surface-primary dark:border dark:border-dark-input-border':
            whiteBgChildren,
          '!p-0': withoutPadding,
        })}
      >
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;
